import { useTrailerShowtimes } from '@/hooks/showtimes/trailer-showtimes';
import { useTheaterContext } from '@/hooks/state/theater';
import { MoviePoster } from '@/types/movie-poster';
import { MoviePosterComponent } from '../movie-poster/movie-poster';

type MovieCarouselProps = {
  dataLinkCategory: string;
  date?: Date;
  index: number;
  movie: MoviePoster;
  titleClassName: string;
  zipCode?: string;
};

export const MovieCarouselItemComponent = ({ dataLinkCategory, date, index, movie, titleClassName, zipCode }: MovieCarouselProps): React.JSX.Element => {
  const { data: theater } = useTheaterContext();
  const {
    hasActiveShowtimes,
    isShowtimesLoading,
    showtimes,
    theaterId,
    theaterName,
    timeZone,
  } = useTrailerShowtimes({
    date: theater?.timeZone ? date : undefined,
    movieId: movie.cinemarkMovieId,
    preferredTheaterId: theater?.theaterId,
    zipCode,
  });
  const movieWithTheater = {
    ...movie,
    theaterId: theaterId ?? movie.theaterId,
    theaterName: theaterName ?? movie.theaterName,
  };

  return (
    <MoviePosterComponent showAdvanceTickets
      showTitle
      dataLinkCategory={dataLinkCategory}
      dataLinkName={`Movie ${index + 1}`}
      hasActiveShowtimes={hasActiveShowtimes}
      index={index}
      isShowtimesLoading={isShowtimesLoading}
      movie={movieWithTheater}
      posterClassName="w-[150px] md:w-[250px]"
      showtimes={showtimes}
      theaterName={theaterName}
      timeZone={timeZone}
      titleClassName={titleClassName}
      titleDataLinkName={`Movie Title ${index + 1}`}
      trailerDataLinkName={`Trailer Click ${index + 1}`}
      watchlistIconClassName="icon-light"
    />
  );
};
